import { c as _c } from "react/compiler-runtime";
import type { ElementType, HTMLAttributes, ReactElement } from 'react';
import { cn } from '#cn';
import { gapClasses, type LayoutGap } from './layout-classes';
type CentreProps = HTMLAttributes<HTMLElement> & {
  gap?: LayoutGap;
  inline?: boolean;
  as?: ElementType;
};

/** Centres its children both horizontally and vertically via flexbox. */
export const Centre = t0 => {
  const $ = _c(16);
  let children;
  let className;
  let gap;
  let inline;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      gap,
      inline,
      as: t1,
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = gap;
    $[4] = inline;
    $[5] = props;
    $[6] = t1;
  } else {
    children = $[1];
    className = $[2];
    gap = $[3];
    inline = $[4];
    props = $[5];
    t1 = $[6];
  }
  const Tag = t1 === undefined ? "div" : t1;
  const t2 = inline ? "inline-flex" : "flex";
  const t3 = gap !== undefined && gapClasses[gap];
  let t4;
  if ($[7] !== className || $[8] !== t2 || $[9] !== t3) {
    t4 = cn(t2, "items-center justify-center", t3, className);
    $[7] = className;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== Tag || $[12] !== children || $[13] !== props || $[14] !== t4) {
    t5 = <Tag className={t4} {...props}>{children}</Tag>;
    $[11] = Tag;
    $[12] = children;
    $[13] = props;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};